import { Pipe, PipeTransform } from '@angular/core';
import { RequestDocument, RequestItem, RequestItemType } from '@aiwyn/api';

@Pipe({
  name: 'hasUploadedFiles',
  pure: true,
  standalone: true
})
export class HasUploadedFilesPipe implements PipeTransform {
  transform(requestItem: RequestItem): boolean {
    if (requestItem.type === RequestItemType.DOCUMENT_REQUEST) {
      const documentItem = requestItem as RequestDocument;
      return documentItem.files && documentItem.files.length > 0;
    }
    return false;
  }
}